// Arabic
export const ar = {
    weeklyRewards: 'المكافآت الأسبوعية في',
    days: 'أيام',
    hours: 'ساعات',
    minutes: 'دقائق',
    seconds: 'ثواني',
    authenticating: 'جاري التحقق',
    verifyWallet: 'يرجى الانتظار بينما نتحقق من محفظتك',
    authRequired: 'التحقق مطلوب',
    authFailed: 'فشل التحقق. يرجى المحاولة مرة أخرى.',
    points: 'نقاط',
    rank: 'المرتبة',
    of: 'من',
    players: 'لاعبين',
    weeklyTopPlayers: 'أفضل اللاعبين أسبوعياً',
    thisWeekLeaderboard: 'لوحة المتصدرين لهذا الأسبوع',
    rankingsReset: 'يتم إعادة تعيين التصنيفات كل يوم أحد في منتصف الليل بتوقيت UTC',
    yourPoints: 'نقاطك',
    dailyRewardAvailable: 'المكافأة اليومية متاحة!',
    nextClaimAvailable: 'المطالبة التالية متاحة في:',
    claimDailyReward: 'المطالبة بالمكافأة اليومية',
    claiming: 'جاري المطالبة...',
    multiplier: 'المضاعف',
    bonusPointsMultiplier: 'مضاعف نقاط المكافأة',
    outOf: 'من',
    loading: 'جاري التحميل...',
    errorLoading: 'خطأ في التحميل',
    noEntries: 'لا توجد مدخلات بعد',
    leaderboard: 'لوحة المتصدرين',
    tasks: 'المهام',
    rules: 'القواعد',
    profile: 'الملف الشخصي',
    comingSoon: 'قريباً...',
    completedTasks: 'المهام المكتملة',
    dailyRewardsClaimed: 'المكافآت اليومية المطالب بها',
    times: 'مرات',
    recentActivity: 'النشاط الأخير',
    noRewardsClaimed: 'لم يتم المطالبة بأي مكافآت بعد',
    dailyReward: 'المكافأة اليومية',
    howItWorks: 'كيف يعمل',
    welcomeMessage:
        'مرحباً بك في Coinomi Rewards! اكسب النقاط بإكمال المهام المختلفة وارتقِ في لوحة المتصدرين.',
    dailyRewardsTitle: 'المكافآت اليومية',
    dailyRewardsRules: [
        'اطلب مكافأتك اليومية كل 24 ساعة',
        'كل مطالبة تمنحك 100 نقطة',
        'تتضاعف النقاط بناءً على المضاعف الخاص بك',
    ],
    multiplierBonusesTitle: 'مكافآت المضاعف',
    multiplierBonusesRules: [
        'ابدأ بمضاعف 1x',
        'اربط تيليجرام للحصول على مكافأة +10%',
        'تحقق من البريد الإلكتروني للحصول على مكافأة +10%',
        'تتراكم المكافآت للحصول على أقصى المكافآت',
    ],
    leaderboardTitle: 'لوحة المتصدرين',
    leaderboardRules: [
        'تنافس مع اللاعبين الآخرين',
        'تحديث التصنيفات في الوقت الفعلي',
        'يحصل أفضل اللاعبين على مكافآت خاصة',
    ],
    boostEarningsTitle: 'عزز أرباحك',
    boostEarningsRules: [
        'أكمل التحديات للحصول على مكافآت',
        'انضم إلى مجتمعنا على تيليجرام',
        'ابق نشطاً لتحقيق أقصى قدر من المكافآت',
    ],
    challenges: 'التحديات',
    telegramChallenge: 'تحدي تيليجرام',
    emailChallenge: 'تحدي البريد الإلكتروني',
    connectTelegram: 'الربط مع تيليجرام',
    shareEmail: 'مشاركة البريد الإلكتروني',
    telegramSuccess: '🎉 تهانينا! أنت الآن تحصل على مكافأة دائمة 10% على جميع المكافآت!',
    telegramPrompt: 'اربط حساب تيليجرام الخاص بك للحصول على مكافأة دائمة 10% على جميع المكافآت!',
    emailSuccess: '🎉 تهانينا! أنت الآن تحصل على مكافأة دائمة 10% على جميع المكافآت!',
    emailPrompt: 'شارك بريدك الإلكتروني للحصول على مكافأة دائمة 10% على جميع المكافآت!',
    connectEmail: 'ربط البريد الإلكتروني',
    cancel: 'إلغاء',
    emailPrivacy: 'نستخدم بريدك الإلكتروني فقط للتحديثات المهمة وإشعارات المكافآت.',
    connectYourEmail: 'اربط بريدك الإلكتروني',
    emailBonus: '🎉 احصل على مكافأة دائمة 10% على جميع المكافآت بربط بريدك الإلكتروني!',
    enterValidEmail: 'يرجى إدخال عنوان بريد إلكتروني صالح',
    emailAddress: 'عنوان البريد الإلكتروني',
    errorSavingEmail: 'خطأ في حفظ البريد الإلكتروني. يرجى المحاولة مرة أخرى.',
    claimButton: 'مطالبة',
    earnedReward: 'المكافأة المكتسبة',
    rewardValue: '{{amount}} نقطة',
    claimSuccess: 'تم المطالبة بنجاح بـ {{amount}} نقطة!',
    claimError: 'فشلت المطالبة بالمكافأة. يرجى المحاولة مرة أخرى.',
    privacyDisclaimer:
        'لا تجمع Coinomi البيانات الشخصية؛ يقوم نظام طرف ثالث بإدارة النقاط والروابط الاجتماعية بشكل آمن.',
    streakBonus: 'مكافأة التتابع',
    streakDays: '{{days}}/5 أيام',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10% إضافي',
    streakDescription: 'طالب 5 أيام متتالية للحصول على أقصى مكافأة',
    streakToday: 'اليوم',
    streakMissed: 'فائت',
    streakComplete: 'مكتمل',
    streakActive: 'تتابع نشط',
    streakLost: 'تم فقدان التتابع',
    streakNext: 'التالي',
    home: 'الرئيسية',
    currentStreak: 'التتابع الحالي',
    totalClaims: 'إجمالي المطالبات',
    userStats: 'إحصائياتك',
    referrals: 'الإحالات',
    referralProgram: 'برنامج الإحالة',
    howReferralWorks: 'كيف تعمل الإحالات:',
    referralSteps: [
        'شارك رابط الإحالة الخاص بك مع الأصدقاء',
        'عندما ينضمون باستخدام رابطك، يصبحون إحالاتك',
        'اكسب نقاط مكافأة لكل إحالة نشطة',
        'تتبع إحالاتك وأرباحك هنا',
    ],
    referralRewards: 'تُمنح نقاط الإحالة:',
    referralBonuses: ['100 نقطة عند إحالة شخص ما', '10% من كل النقاط التي تحصل عليها الإحالة'],
    yourReferralLink: 'رابط الإحالة الخاص بك',
    copyToClipboard: 'نسخ إلى الحافظة',
    linkCopied: 'تم نسخ الرابط إلى الحافظة!',
    totalReferrals: 'إجمالي الإحالات',
    yourReferralCode: 'رمز الإحالة الخاص بك',
    referralCodeCopied: 'تم نسخ رمز الإحالة!',
    editReferralCode: 'تعديل رمز الإحالة',
    editReferralCodeInstructions:
        'اختر رمز إحالة جديد. يجب أن يكون طوله 5 أحرف على الأقل ويمكن أن يحتوي على أحرف وأرقام.',
    newReferralCode: 'رمز الإحالة الجديد',
    referralCodeRequirements: 'الحد الأدنى 5 أحرف، أحرف وأرقام فقط',
    updating: 'جاري التحديث...',
    update: 'تحديث',
    referralCodeTaken: 'رمز الإحالة هذا مستخدم بالفعل',
    haveReferralCode: 'لديك رمز إحالة؟',
    enterReferralCodePrompt: 'إذا قام شخص ما بإحالتك، أدخل رمزه هنا لربط حساباتك.',
    enterReferralCode: 'أدخل رمز الإحالة',
    enterReferralCodeInstructions: 'أدخل رمز الإحالة الذي تمت مشاركته معك.',
    referralCode: 'رمز الإحالة',
    referralCodeFormat: 'أحرف وأرقام فقط',
    submitting: 'جاري الإرسال...',
    submit: 'إرسال',
    enterCode: 'أدخل الرمز',
    pleaseAddtoken: 'يرجى إضافة معلمة token إلى عنوان URL',
    authenticationError: 'حدث خطأ أثناء التحقق',
    noUserFound: 'لم يتم العثور على مستخدم',
    userNotFoundMessage: 'تعذر العثور على بيانات المستخدم',
    backToHome: 'العودة إلى الرئيسية',
    retry: 'إعادة المحاولة',
    baseMultiplier: 'المضاعف الأساسي',
    telegramBonus: 'مكافأة تيليجرام',
    referralChallenge: 'تحدي الإحالة',
    referralChallengePrompt:
        'ادعُ الأصدقاء واكسب نقاط مكافأة! احصل على 100 نقطة لكل إحالة بالإضافة إلى 10% من أرباحهم.',
    startReferring: 'ابدأ الإحالة',
    referralSuccess: '🎉 تهانينا! لقد قمت بإحالة المستخدمين بنجاح وتكسب نقاط مكافأة!',
    unranked: 'غير مصنف',
    noPlayersYet: 'كن أول من ينضم!',
    shareVia: 'مشاركة عبر',
    shareOn: 'مشاركة على {{network}}',
    shareInviteText:
        '🚀 أنا أكسب عملات رقمية مجانية مع @CoinomiWallet!\n\nحمل Coinomi من coinomi.com/downloads وأدخل رمز الإحالة الخاص بي {{referralCode}} للحصول على مكافأة عند الانضمام إلى #Coinomi Rewards في التطبيق.',
    yourStatsThisWeek: 'إحصائياتك هذا الأسبوع',
    pointsMultiplier: 'مضاعف النقاط',
    yourRank: 'رتبتك',
    rewards: 'المكافآت',
    daily: 'يومي',
    weekly: 'أسبوعي',
    claimRewards: 'المطالبة بالمكافآت',
    privacyTitle: 'كوينومي لا تجمع البيانات الشخصية',
    privacyDescription: 'يدير نظام طرف ثالث النقاط والروابط الاجتماعية بشكل آمن.',
    walletAddress: 'عنوان المحفظة',
    darkMode: 'الوضع المظلم',
    player: 'لاعب',
    score: 'نقاط',
    youHaveReferred_zero: 'لم تقم بدعوة أي أصدقاء بعد',
    youHaveReferred_one: 'قمت بدعوة صديق واحد',
    youHaveReferred_two: 'قمت بدعوة صديقين',
    youHaveReferred_few: 'قمت بدعوة {{count}} أصدقاء',
    youHaveReferred_many: 'قمت بدعوة {{count}} صديقاً',
    youHaveReferred_other: 'قمت بدعوة {{count}} صديق',
    referYourFriends: 'ادعُ أصدقاءك',
    dailyRewardTooltip: 'عد كل يوم للمطالبة بنقاطك ومكافآتك',
    weeklyRewardTooltip: 'يتم توزيع مكافآت الإسقاط الجوي أسبوعياً',
    copy: 'نسخ',
    // Twitter Challenge
    twitterChallenge: 'تحدي تويتر',
    connectTwitter: 'ربط تويتر',
    twitterSuccess: '🎉 مبروك! أنت تحصل الآن على مكافأة دائمة بنسبة 10% على جميع المكافآت!',
    twitterPrompt: 'اربط حساب تويتر الخاص بك للحصول على مكافأة دائمة بنسبة 10% على جميع المكافآت!',
    pleaseAddUserId: 'Please add a userId parameter to the URL',
    emailChallengePrompt: 'Share your email to get a permanent 10% bonus on all rewards!',
    emailChallengeSuccess:
        '🎉 Connected! You are now receiving a permanent 10% bonus on all rewards!',
    followKoalaWalletChallenge: 'Follow @coinomiWallet on Twitter to support us!',
    twitterAuthSuccessTitle: 'Twitter Connected Successfully!',
    twitterAuthSuccessMessage:
        'You have successfully connected your Twitter account. You can now continue using the app.',
    continueToApp: 'Continue to App',
    twitter_like: 'Liked a tweet',
    twitter_retweet: 'Retweeted a tweet',
    disconnect: 'قطع الاتصال',
    followCoinomiWallet: 'تابع @coinomiWallet على تويتر لدعمنا!',
    connectedBonus: '🎉 تم الاتصال! أنت الآن تتلقى مكافأة دائمة بنسبة 10% على جميع الجوائز!',
};
